import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useCallback, useMemo } from 'react';
import MuiRating from '@material-ui/lab/Rating';
import { Star, StarBorder } from '@ringcentral/juno-icon';
import { combineClasses, styled, useEventCallback, useThemeProps, } from '../../foundation';
import { RcIcon } from '../Icon';
import { RcTooltip } from '../Tooltip';
import { RatingStyle } from './styles';
import { RcRatingClasses } from './utils';
var defaultSize = 'xlarge';
var defaultIcon = React.createElement(RcIcon, { size: defaultSize, symbol: Star });
var defaultEmptyIcon = React.createElement(RcIcon, { size: defaultSize, symbol: StarBorder });
var _RcRating = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcRating' });
    var TooltipProps = props.TooltipProps, disableTooltip = props.disableTooltip, classesProp = props.classes, onChangeActiveProp = props.onChangeActive, max = props.max, tooltips = props.tooltips, emphasized = props.emphasized, color = props.color, rest = __rest(props, ["TooltipProps", "disableTooltip", "classes", "onChangeActive", "max", "tooltips", "emphasized", "color"]);
    var tooltipOpenStatus = useMemo(function () {
        var tooltipOpenStatus = [];
        for (var i = 0; i < max; i++) {
            tooltipOpenStatus.push(false);
        }
        return tooltipOpenStatus;
    }, [max]);
    var IconContainer = useCallback(function (containerProps) {
        var itemValue = containerProps.value, children = containerProps.children, other = __rest(containerProps, ["value", "children"]);
        return (React.createElement("span", __assign({}, other), !disableTooltip && (tooltips === null || tooltips === void 0 ? void 0 : tooltips[itemValue - 1]) ? (React.createElement(RcTooltip, __assign({ title: tooltips[itemValue - 1], open: !!tooltipOpenStatus[itemValue - 1] }, TooltipProps), children)) : (children)));
    }, [disableTooltip, tooltips, tooltipOpenStatus, TooltipProps]);
    var onChangeActive = useEventCallback(function (e, value) {
        tooltipOpenStatus.forEach(function (v, i) {
            tooltipOpenStatus[i] = i === value - 1;
        });
        onChangeActiveProp === null || onChangeActiveProp === void 0 ? void 0 : onChangeActiveProp(e, value);
    });
    var classes = useMemo(function () { return combineClasses(RcRatingClasses, classesProp); }, [classesProp]);
    return (React.createElement(MuiRating, __assign({ ref: ref, classes: classes, max: max, IconContainerComponent: IconContainer, onChangeActive: onChangeActive }, rest)));
});
var RcRating = styled(_RcRating)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), RatingStyle);
RcRating.defaultProps = {
    icon: defaultIcon,
    emptyIcon: defaultEmptyIcon,
    tooltips: [],
    emphasized: true,
    disableTooltip: false,
    name: 'rating',
    color: 'neutral.f06',
    max: 5,
};
RcRating.displayName = 'RcRating';
export { RcRating };
var templateObject_1;
